/* Midline theme scripts — small, dependency-free */
(function () {
  'use strict';

  // ---------- Mobile menu ----------
  document.querySelectorAll('[data-ml-burger]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  });

  // ---------- Quantity steppers ----------
  document.querySelectorAll('[data-ml-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var min = parseInt(input.min || '0', 10);
        var v = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10);
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Cart: submit the form when a quantity changes
  document.querySelectorAll('[data-ml-cart-form]').forEach(function (form) {
    var timer;
    form.querySelectorAll('[data-ml-qty] input').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { form.submit(); }, 450);
      });
    });
  });

  // ---------- Product gallery ----------
  document.querySelectorAll('[data-ml-gallery]').forEach(function (g) {
    var main = g.querySelector('.ml-pdp__main-img');
    if (!main) return;
    g.querySelectorAll('[data-ml-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full;
        main.alt = t.dataset.alt || '';
        g.querySelectorAll('[data-ml-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // ---------- Variant picker ----------
  document.querySelectorAll('[data-ml-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-ml-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[name="id"]');
    var price = root.querySelector('[data-ml-price]');
    var btn = root.querySelector('[data-ml-add]');
    var addLabel = btn ? btn.dataset.addLabel : '';
    var soldLabel = btn ? btn.dataset.soldLabel : '';
    var money = root.dataset.moneyFormat || '{{amount}}';

    function fmt(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }

    root.querySelectorAll('[data-ml-option]').forEach(function (fs) {
      fs.addEventListener('change', function () {
        var chosen = [];
        root.querySelectorAll('[data-ml-option]').forEach(function (f, i) {
          var c = f.querySelector('input:checked');
          chosen[i] = c ? c.value : null;
          var legendVal = f.querySelector('[data-ml-option-value]');
          if (legendVal && c) legendVal.textContent = c.value;
        });
        var v = product.variants.find(function (x) {
          return x.options.every(function (o, i) { return o === chosen[i]; });
        });
        if (!v) return;
        idInput.value = v.id;
        if (price) {
          price.innerHTML = (v.compare_at_price > v.price ? '<s>' + fmt(v.compare_at_price) + '</s>' : '') + fmt(v.price);
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? addLabel : soldLabel;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  });

  // ---------- Fitment finder ----------
  document.querySelectorAll('[data-ml-finder]').forEach(function (f) {
    var data = JSON.parse(f.querySelector('[data-ml-finder-json]').textContent);
    var make = f.querySelector('[data-ml-make]');
    var model = f.querySelector('[data-ml-model]');
    var go = f.querySelector('[data-ml-go]');
    var msg = f.querySelector('[data-ml-msg]');

    var makes = [];
    data.forEach(function (v) { if (makes.indexOf(v.make) === -1) makes.push(v.make); });
    makes.forEach(function (m) {
      var o = document.createElement('option'); o.value = m; o.textContent = m; make.appendChild(o);
    });

    function fillModels() {
      model.innerHTML = '';
      var first = document.createElement('option');
      first.value = ''; first.textContent = model.dataset.placeholder; model.appendChild(first);
      data.forEach(function (v, i) {
        if (v.make !== make.value) return;
        var o = document.createElement('option');
        o.value = String(i);
        o.textContent = v.years ? v.model + ' (' + v.years + ')' : v.model;
        model.appendChild(o);
      });
      model.disabled = !make.value;
    }
    make.addEventListener('change', fillModels);
    fillModels();

    go.addEventListener('click', function () {
      var v = data[parseInt(model.value, 10)];
      if (v && v.url) { window.location.href = v.url; return; }
      msg.textContent = make.value ? msg.dataset.noMatch : msg.dataset.pickMake;
    });
  });

  // ---------- Hero slideshow ----------
  document.querySelectorAll('[data-ml-slider]').forEach(function (sl) {
    var track = sl.querySelector('[data-ml-track]');
    var slides = sl.querySelectorAll('[data-ml-slide]');
    var dots = sl.querySelectorAll('[data-ml-dot]');
    var count = slides.length;
    if (count < 2) return;
    var index = 0, timer = null, paused = false;
    var secs = parseInt(sl.dataset.autoplay || '0', 10);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function mark(i) {
      index = i;
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function go(i) {
      i = (i + count) % count;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    var prev = sl.querySelector('[data-ml-prev]');
    var next = sl.querySelector('[data-ml-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(index - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(index + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { stop(); go(parseInt(d.dataset.mlDot, 10)); }); });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && i >= 0 && i < count) mark(i);
      });
    }, { passive: true });

    function start() {
      if (secs <= 0 || reduce || paused) return;
      clearInterval(timer);
      timer = setInterval(function () { go(index + 1); }, secs * 1000);
    }
    function stop() { clearInterval(timer); }
    sl.addEventListener('mouseenter', stop);
    sl.addEventListener('mouseleave', start);
    sl.addEventListener('focusin', stop);
    sl.addEventListener('focusout', start);
    track.addEventListener('pointerdown', function () { paused = true; stop(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    // Theme editor: jump to a slide when its block is selected
    document.addEventListener('shopify:block:select', function (e) {
      slides.forEach(function (s, n) { if (s.contains(e.target) || s === e.target) { stop(); go(n); } });
    });
    document.addEventListener('shopify:block:deselect', start);

    start();
  });

  // ---------- Collection filters & sort ----------
  document.querySelectorAll('[data-ml-nav-select]').forEach(function (s) {
    s.addEventListener('change', function () {
      if (s.value) window.location.href = s.value;
    });
  });
})();
